export default {
  SET_USER_ORIGIN_INFO: 'auth/SET_USER_ORIGIN_INFO',
  SET_AUTHORIZATION: 'auth/SET_AUTHORIZATION',
};
